import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  GetUsersForCompanyRequest,
  GetUsersForCompanyResponse,
  GetPermissionGroupsRequest,
  GetPermissionGroupsResponse,
  InviteUserToCompanyRequest,
  InviteUserToCompanyResponse,
  RemoveUserFromCompanyRequest,
  RemoveUserFromCompanyResponse,
  UpdateUserFromCompanyRequest,
  UpdateUserFromCompanyResponse,
  GetUserInvitationDetailsRequest,
  GetUserInvitationDetailsResponse,
  AcceptUserInvitationRequest,
  AcceptUserInvitationResponse,
} from "../../models/UserCompany.model";
import { environment } from "../../environments";

const API_BASE_URL = environment.apiUrl;

// Get Users for Company
export const getUsersForCompany = createAsyncThunk<
  GetUsersForCompanyResponse,
  GetUsersForCompanyRequest,
  { rejectValue: string }
>("userCompany/getUsersForCompany", async (request, { rejectWithValue }) => {
  try {
    const response = await axios.post<GetUsersForCompanyResponse>(
      `${API_BASE_URL}UserCompany/GetUsersForCompany`,
      request,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (!response.data.success) {
      return rejectWithValue(response.data.message);
    }

    return response.data;
  } catch (error: any) {
    if (error.response?.data?.message) {
      return rejectWithValue(error.response.data.message);
    }
    return rejectWithValue("שגיאה בטעינת משתמשי החברה");
  }
});

// Get Permission Groups
export const getPermissionGroups = createAsyncThunk<
  GetPermissionGroupsResponse,
  GetPermissionGroupsRequest,
  { rejectValue: string }
>("userCompany/getPermissionGroups", async (request, { rejectWithValue }) => {
  try {
    const response = await axios.post<GetPermissionGroupsResponse>(
      `${API_BASE_URL}UserCompany/GetPermissionGroups`,
      request,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (!response.data.success) {
      return rejectWithValue(response.data.message);
    }

    return response.data;
  } catch (error: any) {
    if (error.response?.data?.message) {
      return rejectWithValue(error.response.data.message);
    }
    return rejectWithValue("שגיאה בטעינת רשימת הרשאות");
  }
});

// Invite User to Company
export const inviteUserToCompany = createAsyncThunk<
  InviteUserToCompanyResponse,
  InviteUserToCompanyRequest,
  { rejectValue: string }
>("userCompany/inviteUserToCompany", async (request, { rejectWithValue }) => {
  try {
    const response = await axios.post<InviteUserToCompanyResponse>(
      `${API_BASE_URL}UserCompany/InviteUserToCompany`,
      request,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (!response.data.success) {
      return rejectWithValue(response.data.message);
    }

    return response.data;
  } catch (error: any) {
    if (error.response?.data?.message) {
      return rejectWithValue(error.response.data.message);
    }
    return rejectWithValue("שגיאה בהזמנת המשתמש");
  }
});

// Remove User from Company
export const removeUserFromCompany = createAsyncThunk<
  RemoveUserFromCompanyResponse,
  RemoveUserFromCompanyRequest,
  { rejectValue: string }
>("userCompany/removeUserFromCompany", async (request, { rejectWithValue }) => {
  try {
    const response = await axios.post<RemoveUserFromCompanyResponse>(
      `${API_BASE_URL}UserCompany/RemoveUserFromCompany`,
      request,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (!response.data.success) {
      return rejectWithValue(response.data.message);
    }

    return response.data;
  } catch (error: any) {
    if (error.response?.data?.message) {
      return rejectWithValue(error.response.data.message);
    }
    return rejectWithValue("שגיאה במחיקת המשתמש");
  }
});

// Update User Permission Group
export const updateUserPermissionGroup = createAsyncThunk<
  UpdateUserFromCompanyResponse,
  UpdateUserFromCompanyRequest,
  { rejectValue: string }
>(
  "userCompany/updateUserPermissionGroup",
  async (request, { rejectWithValue }) => {
    try {
      const response = await axios.post<UpdateUserFromCompanyResponse>(
        `${API_BASE_URL}UserCompany/UpdateUserPermissionGroup`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (!response.data.success) {
        return rejectWithValue(response.data.message);
      }

      return response.data;
    } catch (error: any) {
      if (error.response?.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue("שגיאה בעדכון הרשאות המשתמש");
    }
  },
);

// Get User Invitation Details
export const getUserInvitationDetails = createAsyncThunk<
  GetUserInvitationDetailsResponse,
  GetUserInvitationDetailsRequest,
  { rejectValue: string }
>(
  "userCompany/getUserInvitationDetails",
  async (request, { rejectWithValue }) => {
    try {
      const response = await axios.post<GetUserInvitationDetailsResponse>(
        `${API_BASE_URL}UserCompany/GetUserInvitationDetails`,
        request,
      );

      if (response.data.success) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message);
      }
    } catch (error: any) {
      if (error.response?.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue("שגיאה בטעינת פרטי ההזמנה");
    }
  },
);

// Accept User Invitation
export const acceptUserInvitation = createAsyncThunk<
  AcceptUserInvitationResponse,
  AcceptUserInvitationRequest,
  { rejectValue: string }
>("userCompany/acceptUserInvitation", async (request, { rejectWithValue }) => {
  try {
    const response = await axios.post<AcceptUserInvitationResponse>(
      `${API_BASE_URL}UserCompany/AcceptUserInvitation`,
      request,
    );

    if (response.data.success) {
      return response.data;
    } else {
      return rejectWithValue(response.data.message);
    }
  } catch (error: any) {
    if (error.response?.data?.message) {
      return rejectWithValue(error.response.data.message);
    }
    return rejectWithValue("שגיאה באישור ההזמנה");
  }
});
